function getProfitAlertLabel(item) {
  if (!item?.userId) return "회원";
  return item.userName ? `${item.userName}(${item.userId})` : item.userId;
}

export function getProfitAlertEventKey(item) {
  const dateId = item?.dateId ?? "unknown";
  const userId = item?.userId ?? "unknown";
  const triggeredAt = item?.triggeredAt ?? "unknown";

  return `${dateId}:${userId}:${triggeredAt}`;
}

export function buildProfitAlertPopupConfig(item) {
  const label = getProfitAlertLabel(item);
  const userId = item?.userId ?? "unknown";
  const dateId = item?.dateId ?? "unknown";

  return {
    popupType: "profitAlert",
    notification: {
      title: "HTS Manager",
      body: `${label} 일일 실현손익 임계값 돌파`,
      tag: `profit-alert-${dateId}-${userId}`,
      data: {
        type: "profitAlert",
        userId: item?.userId ?? null,
      },
    },
  };
}

export function createTimedEventGate({
  ttlMs = 3000,
  now = () => Date.now(),
} = {}) {
  const seenAt = new Map();

  return {
    shouldProcess(key) {
      const current = now();

      for (const [entryKey, timestamp] of seenAt.entries()) {
        if (current - timestamp > ttlMs) {
          seenAt.delete(entryKey);
        }
      }

      const lastSeen = seenAt.get(key);
      if (lastSeen !== undefined && current - lastSeen <= ttlMs) {
        return false;
      }

      seenAt.set(key, current);
      return true;
    },

    clear() {
      seenAt.clear();
    },
  };
}
